/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ListShapesPayload } from '../models/ListShapesPayload'
import type { ListShapesResponseModel } from '../models/ListShapesResponseModel'
import type { Page_MatchedPolicyRuleSchedule_ } from '../models/Page_MatchedPolicyRuleSchedule_'
import type { PolicyType } from '../models/PolicyType'
import type { PolicyUnits } from '../models/PolicyUnits'
import type { ShapesResultModel } from '../models/ShapesResultModel'
import type { VehicleTypeEnum } from '../models/VehicleTypeEnum'
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class ShapesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Get Shape
   * Get a single shape from a UUID.
   * @returns ShapesResultModel Successful Response
   * @throws ApiError
   */
  public getShape({
    regionId,
    shapeUuid,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Shape identifier
     */
    shapeUuid: string
  }): CancelablePromise<ShapesResultModel> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/shapes/{shape_uuid}',
      path: {
        region_id: regionId,
        shape_uuid: shapeUuid,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * Get Policies By Shape
   * Get Policies relating to a single shape from a UUID.
   * @returns Page_MatchedPolicyRuleSchedule_ Successful Response
   * @throws ApiError
   */
  public getPoliciesByShape({
    regionId,
    shapeUuid,
    startDate,
    endDate,
    purposes,
    vehicleTypes,
    userClasses,
    types,
    hasRate,
    maximum,
    unit,
    daysOfWeek,
    ruleIds,
    page = 1,
    size = 50,
    startTime,
    endTime,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Shape identifier
     */
    shapeUuid: string
    /**
     * Filter for policies and compliance records that end after the provided ISO start date (inclusive)
     */
    startDate: string | null
    /**
     * Filter for policies and compliance records that started on or before the provided ISO end date (inclusive)
     */
    endDate: string | null
    /**
     * Filter for purposes
     */
    purposes?: Array<string> | null
    /**
     * Filter for vehicle_types
     */
    vehicleTypes?: Array<VehicleTypeEnum> | null
    /**
     * Filter for user_classes
     */
    userClasses?: Array<string> | null
    /**
     * Filter for types
     */
    types?: Array<PolicyType> | null
    /**
     * True to filter for policy rules with rates
     */
    hasRate?: boolean | null
    /**
     * Filter policy rule maximum by providing two numbers representing a range (inclusive)
     */
    maximum?: Array<number> | null
    /**
     * Filter by policy rule unit
     */
    unit?: PolicyUnits | null
    /**
     * Filter policy rules for those that apply weekly on ISO days of week
     */
    daysOfWeek?: Array<number> | null
    /**
     * Filter policy rules by rule IDs
     */
    ruleIds?: Array<string> | null
    page?: number
    size?: number
    /**
     * Filter policy rules that apply after the provided time in format HH:mm (inclusive)
     */
    startTime?: string | null
    /**
     * Filter policy rules that apply before the provided time in format HH:mm (exclusive)
     */
    endTime?: string | null
  }): CancelablePromise<Page_MatchedPolicyRuleSchedule_> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/shapes/{shape_uuid}/all_policies',
      path: {
        region_id: regionId,
        shape_uuid: shapeUuid,
      },
      query: {
        purposes: purposes,
        vehicle_types: vehicleTypes,
        user_classes: userClasses,
        types: types,
        has_rate: hasRate,
        maximum: maximum,
        unit: unit,
        days_of_week: daysOfWeek,
        rule_ids: ruleIds,
        page: page,
        size: size,
        start_date: startDate,
        end_date: endDate,
        start_time: startTime,
        end_time: endTime,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
  /**
   * List Shapes Deprecated
   * Returns shapes for a specific layer uuid.  region_id is also required
   * to make sure the user has access to this layer.
   * @returns ListShapesResponseModel Successful Response
   * @throws ApiError
   */
  public listShapesDeprecated({
    regionId,
    requestBody,
  }: {
    /**
     * Region identifier
     */
    regionId: string
    requestBody: ListShapesPayload
  }): CancelablePromise<ListShapesResponseModel> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/regions/{region_id}/shapes/list',
      path: {
        region_id: regionId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
